import Axios from 'axios';
import router from '../router';

export default {
	state: {
		schoolsDropdown: null,
		reasonsDropdown: null,
		callerTypesDropdown: null
	},
	mutations: {
		SET_DROPDOWN_SCHOOLS (state, schools) {
			state.schoolsDropdown = schools;
		},
		SET_DROPDOWN_REASONS (state, reasons) {
			state.reasonsDropdown = reasons;
		},
		SET_DROPDOWN_CALLER_TYPES (state, callerTypes) {
			state.callerTypesDropdown = callerTypes;
		}
	},
	actions: {
		async getDropdownSchools (context) {
			try {
				const response = await Axios.get('/dropdowns/schools');
				context.commit('SET_DROPDOWN_SCHOOLS', response.data);
			} catch (error) {
				console.log(error);
			}
		},
		async getDropdownReasons (context) {
			try {
				const response = await Axios.get('/callcenter/dropdowns/reasons');
				context.commit('SET_DROPDOWN_REASONS', response.data);
			} catch (error) {
				console.log(error);
			}
		},
		async getDropdownCallerTypes (context) {
			try {
				const response = await Axios.get('/callcenter/dropdowns/caller-types');
				context.commit('SET_DROPDOWN_CALLER_TYPES', response.data);
			} catch (error) {
				console.log(error);
			}
		}
	}
};



// WEBPACK FOOTER //
// ./src/store/dropdowns.js